import { InferType, object, string } from 'yup';

export const formValuesSchema = object().shape({
  search: string().default('').optional(),
  policyNumber: string().default('').optional(),
});

export type FormValues = InferType<typeof formValuesSchema>;
